import { CrossIcon } from 'assets/icons';
import { DisableBodyScroll } from 'components/DisableBodyScroll';
import React from 'react';
import ReactDOM from 'react-dom';
import DocumentEvents from 'utils/document-events';

import * as S from './modal.styles';

interface IModalProps {
  onClose(): void;
  ignoreFormStyling?: boolean;
  children: ((closeModal: () => void) => React.ReactNode) | React.ReactNode;
}

interface IModalState {
  isClosing: boolean;
}

class ModalComponent extends React.Component<IModalProps, IModalState> {
  private element: HTMLDivElement;

  state: IModalState = {
    isClosing: false,
  };

  componentDidMount() {
    DocumentEvents.escapeListener(this.closeModal);
    this.element.addEventListener('click', this.closeModalIfClickedOutside, false);
    this.element.addEventListener('transitionend', this.onTransitionEnd, false);
  }

  componentWillUnmount() {
    DocumentEvents.removeEscapeListener(this.closeModal);
    this.element.removeEventListener('click', this.closeModalIfClickedOutside);
  }

  closeModalIfClickedOutside = (event: MouseEvent) => {
    if (event.target === this.element) {
      this.closeModal();
    }
  };

  closeModal = () => {
    if (!this.state.isClosing) {
      this.setState({ isClosing: true });
    }
  };

  onTransitionEnd = () => {
    if (this.state.isClosing) {
      this.element.removeEventListener('transitionend', this.onTransitionEnd, false);
      this.props.onClose();
    }
  };

  render() {
    const { children } = this.props;
    const { isClosing } = this.state;

    return (
      <S.ModalWrapper
        isClosing={isClosing}
        ref={(element: HTMLDivElement) => {
          this.element = element;
        }}>
        <S.Modal isClosing={isClosing} ignoreFormStyling={this.props.ignoreFormStyling} data-testid="modal">
          <S.CloseButton onClick={this.closeModal} data-testid="modal-close-button">
            <CrossIcon />
          </S.CloseButton>
          {children instanceof Function ? children(this.closeModal) : children}
          <DisableBodyScroll />
        </S.Modal>
      </S.ModalWrapper>
    );
  }
}

export class Modal extends React.Component<IModalProps> {
  private modalRoot: HTMLElement | null;

  constructor(props: IModalProps) {
    super(props);
    this.modalRoot = document.getElementById('modal-root');
  }

  render() {
    const { children, ...rest } = this.props;

    if (!this.modalRoot) {
      return null;
    }

    return ReactDOM.createPortal(<ModalComponent {...rest}>{children}</ModalComponent>, this.modalRoot);
  }
}
